import { Button, ButtonProps } from '@atoms/index';
import { FormTitle } from '@molecules/index';
import { ConfirmationBanner } from '@organisms/index';
import { FeedbackLink } from '@molecules/*';
import React from 'react';

interface ConfirmationTemplateProps {
  reference?: string | undefined;
  contentTitle?: string;
  contentSubtext?: string | React.ReactNode;
  content?: React.ReactNode;
  feedbackLink?: boolean;
  button?: ButtonProps;
}
export const ConfirmationTemplate: React.FC<ConfirmationTemplateProps> = ({
  reference,
  contentTitle,
  contentSubtext,
  content,
  feedbackLink,
  button,
}) => {
  return (
    <>
      <div className="-mx-[1.5rem]">
        <ConfirmationBanner reference={reference} />
      </div>
      <section data-testid="content" className="my-4 flex flex-col">
        {contentTitle ? (
          <FormTitle text={contentTitle} subtext={contentSubtext} />
        ) : (
          <>{content}</>
        )}
      </section>
      <section className="mt mb-4">{feedbackLink && <FeedbackLink />}</section>
      {button ? (
        <section data-testid="navigate-to-homepage">
          <Button
            id="navigation-button"
            variant="navigation"
            color="navigation-primary"
            label={button.label}
            onClick={button.onClick}
            size="extraLarge"
            {...button}
          />
        </section>
      ) : null}
    </>
  );
};
